import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import { registerMicroApps, start } from 'qiankun';
import { resetHostScroll } from './utils/qiankun';

const rootNode = document.getElementById('app')!;

const root = ReactDOM.createRoot(rootNode);
registerMicroApps(
  [
    {
      name: 'OTAMicroApp',
      entry: process.env.JDX_APP_OTA_URL!,
      container: '#qiankun-root',
      activeRule: '/ota',
    },
    {
      name: 'OTAExtMicroApp',
      entry: process.env.JDX_APP_OTA_EXT_URL!,
      container: '#qiankun-root',
      activeRule: '/ota_ext',
    },
    {
      name: 'OTA2.0MicroApp',
      entry: process.env.JDX_APP_OTA_UI_URL!,
      container: '#qiankun-root',
      activeRule: '/ota-ui',
    },
  ],
  {
    beforeLoad: () => {
      return Promise.resolve();
    },
    beforeMount: () => {
      resetHostScroll();
      return Promise.resolve();
    },
    afterMount: () => {
      resetHostScroll();
      return Promise.resolve();
    },
    beforeUnmount: () => {
      return Promise.resolve();
    },
    afterUnmount: () => {
      return Promise.resolve();
    },
  },
);
start();
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);
